<script lang="ts" setup>
import { Link } from '~/types'
import { Employee } from '~/views/cms/components/EmployeeSingle.vue'

export interface OpenJobContact {
  title: string
  tagline: string
  link: Link
  employee: Employee
}
defineProps<{ data: OpenJobContact }>()
</script>
<template>
  <article class="open-job">
    <div class="job">
      <h2 class="title">{{ data.title }}</h2>
      <Button v-if="data.link.url" primary slide :to="data.link.url">
        {{ data.link.text }}
      </Button>
    </div>
    <div class="contact">
      <Image v-if="data.employee.image" :entity="data.employee.image" type="author-thumbnail" />
      <p class="tagline label">{{ data.tagline }}</p>
      <h3 class="name">{{ data.employee.name }}</h3>
      <p class="position text-small" v-html="data.employee.position" />

      <div class="cta">
        <span class="label">Tel</span>
        <a class="link-default text-small" :href="`tel:${data.employee.phone}`">{{ data.employee.phone }}</a>
      </div>
    </div>
  </article>
</template>
<style lang="scss" scoped>
.open-job {
  min-height: 100%;

  display: flex;
  flex-direction: column;

  padding: 30px 24px 48px;
  background-color: var(--c-background-medium);
  @include breakpoint(tl) {
    padding: 64px 96px;
  }
}

.job {
  @include fluid(margin-bottom, 48px, 72px);
}

.contact {
  margin-top: auto;
  border-top: 1px solid var(--c-line-light);
  @include fluid(padding-top, 18px, 24px);
}
.dp-image {
  border-radius: 50%;
  aspect-ratio: 1;

  @include fluid(width, 100px, 120px);
  @include fluid(margin-bottom, 18px, 24px);
}
.tagline {
  color: var(--c-primary);
  @include fluid(margin-bottom, 12px, 16px);
}

.name {
  margin-bottom: 0;
}

.cta {
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  @include breakpoint(ts) {
    align-items: center;
    flex-direction: row;
    gap: 2rem;
  }
}
</style>
